<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Yo‘l belgilari' }]" />

      <a-row :gutter="[16, 16]">
        <a-col v-for="item in signs" :key="item.id" :xs="24" :sm="12" :md="8">
          <a-card class="custom-card">
            <img :src="item.image" style="width:120px; height:120px; object-fit:contain; display:block; margin:0 auto 12px;" />
            <h3>{{ item.name }}</h3>
            <p>{{ item.desc }}</p>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb
  },
  computed: {
    signs() {
      return this.$store.getters.roadSigns
    }
  }
}
</script>